// This is a list of fields returned from the server which we will display field level validation
// for.  Anything else will be captured by the generic failure message.
export const serversideErrorFields = ['title', 'description'];

export const getServersideErrorsToDisplayErrorsFor = (formErrors: Record<string, string[]>) => {
    const validErrors = {};

    serversideErrorFields.forEach((fieldName) => {
        const fieldError = formErrors[fieldName];

        if (fieldError) {
            validErrors[fieldName] = fieldError;
        }
    });

    return validErrors;
};
